import { render, staticRenderFns } from "./SystemParamter.vue?vue&type=template&id=4da385b9&scoped=true&"
import script from "./SystemParamter.vue?vue&type=script&lang=js&"
export * from "./SystemParamter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da385b9",
  null
  
)

export default component.exports